export const ErrorCodes = {
  invalidStockLocation: 'order.invalid.stock.location'
}
